<template>
    <div class="response-table">
      <h4 class="text-lg font-semibold mb-3">Response Table</h4>
      <div class="overflow-hidden border border-gray-200 rounded-lg">
        <table class="min-w-full divide-y divide-gray-200">
          <thead class="bg-gray-800">
            <tr>
              <th scope="col" class="px-6 py-3 text-left text-sm font-medium text-white">
                Raters
              </th>
              <th scope="col" class="px-6 py-3 text-right text-sm font-medium text-white">
                Students
              </th>
            </tr>
          </thead>
          <tbody class="bg-white divide-y divide-gray-200">
            <tr class="bg-white">
              <td class="px-6 py-4 text-sm text-gray-900">
                Responded
              </td>
              <td class="px-6 py-4 text-sm text-gray-900 text-right">
                {{ formatNumber(data.responded) }}
              </td>
            </tr>
            <tr class="bg-gray-50">
              <td class="px-6 py-4 text-sm text-gray-900">
                Invited
              </td>
              <td class="px-6 py-4 text-sm text-gray-900 text-right">
                {{ formatNumber(data.invited) }}
              </td>
            </tr>
            <tr class="bg-white">
              <td class="px-6 py-4 text-sm text-gray-900">
                Response Ratio
              </td>
              <td class="px-6 py-4 text-sm text-gray-900 text-right">
                {{ formatPercentage(data.responded / data.invited) }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'ResponseTable',
    props: {
      data: {
        type: Object,
        required: true,
        default: () => ({
          responded: 0,
          invited: 0
        })
      }
    },
    methods: {
      formatNumber(number) {
        return new Intl.NumberFormat().format(number);
      },
      formatPercentage(ratio) {
        return `${(ratio * 100).toFixed(1)}%`;
      }
    }
  }
  </script>
  
  